// ======================================================================
// File Name       : SuperUserNavigatorConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import * as ICON from './IconConstants';
import * as Path from './PathConstants';

const SUPERUSER_NAVIGATOR_CONFIG = [
  {
    title: 'サービス情報',
    path: Path.SERVICE_DETAIL,
    id: 'SERVICE_DETAIL',
    icon: ICON.INFORMATION,
  },
];

export default SUPERUSER_NAVIGATOR_CONFIG;
